/* ============================================
   ScheduledBubble — Displays a scheduled message
   in the chat thread with cancel/status support
   ============================================ */
import { IconClock, IconX } from '@/components/icons/Icons'
import type { MensajeProgramado } from '@/lib/types'

interface ScheduledBubbleProps {
  programado: MensajeProgramado
  onCancel: (id: number) => void
  onImageClick?: (url: string) => void
  onPdfClick?: (url: string, name: string) => void
}

/** Format scheduled date for display */
function formatScheduledDate(isoStr: string): string {
  const d = new Date(isoStr)
  const weekday = d.toLocaleDateString('es-PE', { weekday: 'short' })
  const day = d.getDate()
  const month = d.toLocaleDateString('es-PE', { month: 'short' })
  const hours = d.getHours()
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const h12 = hours % 12 || 12
  const ampm = hours < 12 ? 'AM' : 'PM'
  const cap = weekday.charAt(0).toUpperCase() + weekday.slice(1)
  return `${cap} ${day} ${month}, ${h12}:${minutes} ${ampm}`
}

export default function ScheduledBubble({ programado, onCancel }: ScheduledBubbleProps) {
  const { id, contenido, fecha_programada, scheduled_at, estado } = programado
  const scheduledDate = scheduled_at || fecha_programada

  // Don't render cancelled messages
  if (estado === 'cancelado' || estado === 'enviado') return null

  const containerClass = [
    'scheduled-bubble',
  ].filter(Boolean).join(' ')

  return (
    <div className={containerClass}>
      {/* Header: clock + date */}
      <div className="scheduled-bubble__header">
        <IconClock size={14} />
        <span>Programado para {formatScheduledDate(scheduledDate)}</span>

        {/* Cancel button — only for pendiente */}
        {estado === 'pendiente' && (
          <button
            className="scheduled-bubble__cancel"
            onClick={() => onCancel(id)}
            type="button"
            title="Cancelar envío"
          >
            <IconX size={14} />
          </button>
        )}
      </div>

      {/* Content */}
      <div className="scheduled-bubble__content">
        {contenido && (
          <p className="scheduled-bubble__text">{contenido}</p>
        )}
      </div>
    </div>
  )
}
